import React from 'react';

const AbstractAIBackground = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 500 800" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#26133D" />
          <stop offset="30%" stopColor="#341c52" />
          <stop offset="70%" stopColor="#231634" />
          <stop offset="100%" stopColor="#171713" />
        </linearGradient>
      </defs>
      
      {/* Background */}
      <rect width="100%" height="100%" fill="url(#bgGradient)" />
    </svg>
  );
};

export default AbstractAIBackground; 